const newNotificationReducer = (state, action) => ({
  ...state,
  newNotification: { ...action.payload.notification },
});

export default newNotificationReducer;
